import { components, SingleValueProps } from 'react-select';

const SingleValue = ({ children, ...props }: SingleValueProps) => (
  <components.SingleValue {...props}>
    <label htmlFor={props.selectProps.inputId}>{children}</label>
  </components.SingleValue>
);

export default SingleValue;
